/**
 * Short numeric dates for results dashboards (own + team, comparisons, charts).
 * Uses the app language; generic `en` maps to en-GB for day-first (European) order.
 */

export const LOCALE_DATE_SHORT_OPTIONS = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

/**
 * Map vue-i18n locale codes to BCP-47 for date formatting.
 * @param {string} [i18nLocale]
 * @returns {string}
 */
export function resolveLocaleForDateFormat(i18nLocale) {
  if (!i18nLocale || i18nLocale === 'en') return 'en-GB';
  return i18nLocale;
}

/**
 * @param {string|number|Date|null|undefined} value
 * @param {string} [i18nLocale]
 * @returns {string}
 */
export function formatLocaleDate(value, i18nLocale) {
  if (value == null || value === '') return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(
    resolveLocaleForDateFormat(i18nLocale),
    LOCALE_DATE_SHORT_OPTIONS,
  );
}

/** Long month name, e.g. DE "02. März 2026", EN-GB "02 March 2026" */
const LOCALE_DATE_LONG_OPTIONS = {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
};

/**
 * @param {string|number|Date|null|undefined} value
 * @param {string} [i18nLocale]
 * @returns {string}
 */
export function formatLocaleDateLong(value, i18nLocale) {
  if (value == null || value === '') return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(
    resolveLocaleForDateFormat(i18nLocale),
    LOCALE_DATE_LONG_OPTIONS,
  );
}
